import React, {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import './style.scss';
import {iniFrame} from "../../serviceWorker";

const Footer: FunctionComponent = () => {
  const {t: translate} = useTranslation();

  return (
    <div className='footer'>
      {iniFrame() && (
        <div className='rights-reserved'>
          © {new Date().getFullYear()} {translate('views.footer.all_rights_reserved')}
        </div>
      )}
      {!iniFrame() && (
        <div className='links'>
          <div className='terms-of-use'>
            {translate('views.footer.terms')}
          </div>
          <div className='link' onClick={() => {
            window.open('https://www.backuplabs.io/terms-of-use', '_blank');
          }}>
            {translate('common.default_pages.terms_of_use')},
          </div>
          <div className='link' onClick={() => {
            window.open('https://www.backuplabs.io/static-files/sla.pdf', '_blank');
          }}>
            {translate('common.default_pages.sla')}
          </div>
          &
          <div className='link' onClick={() => {
            window.open('https://www.backuplabs.io/privacy', '_blank');
          }}>
            {translate('common.default_pages.privacy_policy')}
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
